//
// SASReportState.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "../BIRDSchema";
import "../results/DataParameter";
import "./viewState/ViewState";
import "./dataState/DataState";
import "./visualElementState/VisualElementState";

var SASReportState = createModule("BIRD::SASReportState", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        date: 7,
        xmlns: 1,
        createdVersion: 7,
        parameterStates: [1],
        viewState: 1,
        dataState: 1,
        visualElementStates: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SASReportState;
